//"App.tsx"
import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown, Button, Form, Alert, Table, Modal } from 'react-bootstrap';
import { FaHome, FaUser, FaCog, FaSignInAlt, FaSignOutAlt, FaLanguage, FaUtensils, FaUpload } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './i18n';
import RecipeSearch from './RecipeSearch';
//import RecipeDetail from './RecipeDetail';
import RecipeDetail5 from './RecipeDetail5';
//import RecipeForm from './RecipeForm';
import RecipeForm5 from './RecipeForm5';
import UploadsGrid from './UploadsGrid';
//import { Recipe } from './tipos/Recipe';

interface User {
  id: number;
  username: string;
  isAdmin: boolean;
}

interface Template {
  content: string;
}

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [user, setUser] = useState<User | null>(null);


  // ApartadoB state
  const [template, setTemplate] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>('');
  const [fileInputKey, setFileInputKey] = useState<number>(0);

  // ApartadoC state
  const [users, setUsers] = useState<User[]>([]);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState<boolean>(false);
  const [userToDelete, setUserToDelete] = useState<User | null>(null);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    console.log('Leyendo user:', storedUser);
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      setIsLoggedIn(true);
      setIsAdmin(parsedUser.isAdmin);
    }
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetchUsers();
    }
  }, [isAdmin]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get<User[]>('https://rednext31.ddns.net:3005/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  //TIP 1
  // const videoURL = 'https://www.youtube.com/watch?v=RLWJQ5YFWYA';
  // const encodedURL = encodeURIComponent(videoURL);
  // // Luego, puedes usarla en una solicitud fetch o en una ruta
  // fetch(`/videos/${encodedURL}`, {
  //   method: 'PUT',
  //   // Otros parámetros de la solicitud si son necesarios
  // })
  //   .then(response => response.json())
  //   .then(data => console.log(data))
  //   .catch(error => console.error('Error:', error));


  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post<User>('https://rednext31.ddns.net:3005/api/login', { username, password });
      setIsLoggedIn(true);
      setIsAdmin(response.data.isAdmin);
      setUser(response.data);
      setError('');
      sessionStorage.setItem('user', JSON.stringify(response.data));
    } catch (error) {

      setError(t('login.invalidCredentials'));
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setIsAdmin(false);
    setUser(null);
    sessionStorage.removeItem('user');
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // Manejar la inactividad del usuario y cerrar sesión
  useEffect(() => {
    if (isLoggedIn) {
      let timeout: NodeJS.Timeout;

      const resetTimeout = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          handleLogout();
          alert('Has sido desconectado por inactividad.');
        }, 30 * 60 * 1000); // 30 minutos
      };

      // Detectar actividad del usuario
      window.addEventListener('mousemove', resetTimeout);
      window.addEventListener('keydown', resetTimeout);
      window.addEventListener('click', resetTimeout);

      // Iniciar el temporizador
      resetTimeout();

      // Limpiar eventos al desmontar el componente
      return () => {
        clearTimeout(timeout);
        window.removeEventListener('mousemove', resetTimeout);
        window.removeEventListener('keydown', resetTimeout);
        window.removeEventListener('click', resetTimeout);
      };
    }
  }, [isLoggedIn]);

  // ApartadoA component
  const ApartadoA = () => {
    const [template, setTemplate] = useState<string>('');

    useEffect(() => {
      axios.get<Template>('https://rednext31.ddns.net:3005/api/templates/1') // ID de la plantilla A
        .then(response => setTemplate(response.data.content))
        .catch(error => console.error('Error fetching template:', error));
    }, []);

    return <div>{template}</div>;
  };


  // ApartadoB functions
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'image/jpeg') {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      alert(t('apartadoB.selectJpgFile'));
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert(t('apartadoB.selectFileFirst'));
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await axios.post('https://rednext31.ddns.net:3005/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert(t('apartadoB.uploadSuccess'));
      setSelectedFile(null);
      setPreviewUrl('');
      setFileInputKey(prev => prev + 1);
    } catch (error) {
      console.error('Error uploading file:', error);
      alert(t('apartadoB.uploadError'));
    }
  };
  // ApartadoB component
  const ApartadoB = () => {
    useEffect(() => {
      axios.get<Template>('https://rednext31.ddns.net:3005/api/templates/2')
        .then(response => setTemplate(response.data.content))
        .catch(error => console.error('Error fetching template:', error));
    }, []);

    return (
      <Container>
        <h2>{t('apartadoB.title')}</h2>
        <div dangerouslySetInnerHTML={{ __html: template }} />
        <Form>
          <Form.Group controlId="formFile">
            <Form.Label>{t('apartadoB.selectFile')}</Form.Label>
            <Form.Control 
              key={fileInputKey} 
              type="file" 
              accept=".jpg" 
              onChange={handleFileChange} 
            />
          </Form.Group>
          <Button variant="outline-primary" onClick={handleUpload}  disabled={!selectedFile}>{t('apartadoB.uploadFile')}</Button>
        </Form>
        {previewUrl && (
          <div style={{ marginTop: '20px' }}>
            <h3>{t('apartadoB.preview')}</h3>
            <img src={previewUrl} alt="Preview" style={{ maxWidth: '100%', height: 'auto' }} />
          </div>
        )}
        <UploadsGrid />
      </Container>
    );
  };
  // ApartadoC functions
  const handleCreate = async () => {
    try {
      const response = await axios.post<User>('https://rednext31.ddns.net:3005/api/users', { username, password, isAdmin });
      setUsers([...users, response.data]);
      setUsername('');
      setPassword('');
      setIsAdmin(false);
      setShowModal(false);
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };
  //  Edicion de Usuario 
  const handleUpdate = async () => {
    if (editingUser) {
      try {
        await axios.put<User>(`https://rednext31.ddns.net:3005/api/users/${editingUser.id}`, { username, password, isAdmin });
        setUsers(users.map(user => user.id === editingUser.id ? { ...user, username, isAdmin } : user));
        setEditingUser(null);
        setShowModal(false);
      } catch (error) {
        console.error('Error updating user:', error);
      }
    }
  };

  const confirmDeleteUser = (user: User) => {
    setUserToDelete(user);
    setShowDeleteConfirm(true);
  };

  const handleDelete = async () => {
    if (userToDelete) {
      try {
        await axios.delete(`https://rednext31.ddns.net:3005/api/users/${userToDelete.id}`);
        setUsers(users.filter(user => user.id !== userToDelete.id));
        setShowDeleteConfirm(false);
        setUserToDelete(null);
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  // ApartadoC component
  const ApartadoC = () => (
    <Container>
      <h2>{t('gestion-de-usuarios')}</h2>
      <Button variant="outline-primary" onClick={() => { setEditingUser(null); setShowModal(true); }}>{t('anadir-usuario')}</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>{t('username')}</th>
            <th>{t('admin')}</th>
            <th>{t('acciones')}</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.isAdmin ? t('si') : t('no-0')}</td>
              <td>
                <Button variant="outline-warning" onClick={() => { setEditingUser(user); setUsername(user.username); setIsAdmin(user.isAdmin); setShowModal(true); }}>
                  {t('editar')}
                </Button>
                <Button variant="outline-danger" onClick={() => confirmDeleteUser(user)} className="ml-2">
                  {t('eliminar')}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingUser ? t('editar-usuario') : t('anadir-usuario')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formUsername">
              <Form.Label>{t('username')}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t('enter-username')}
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>{t('password')}</Form.Label>
              <Form.Control
                type="password"
                placeholder={t('enter-password')}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formIsAdmin">
              <Form.Check
                type="checkbox"
                label={t('administrador')}
                checked={isAdmin}
                onChange={e => setIsAdmin(e.target.checked)}
              />
            </Form.Group>
            <Button variant="outline-primary" onClick={editingUser ? handleUpdate : handleCreate}>
              {editingUser ? t('actualizar-usuario') : t('crear-usuario')}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('confirmar-eliminacion')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('estas-seguro-de-que-deseas-eliminar-el-usuario')} "{userToDelete?.username}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowDeleteConfirm(false)}>
            {t('cancelar')}
          </Button>
          <Button  variant="outline-danger" onClick={handleDelete}>
            {t('eliminar')}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );

  return (
    <Router>
      <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand as={Link} to="/"><FaUtensils className="me-2" />{t('app.title')}</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">
                <FaHome className="me-1" /> {t('nav.home')}
              </Nav.Link>
              {isLoggedIn && (
                <>
                  <Nav.Link as={Link} to="/apartadoB">
                    <FaUpload className="me-1" /> {t('nav.apartadoB')}
                  </Nav.Link>
                </>
              )}
              {isLoggedIn && (
                <Nav.Link as={Link} to="/apartadoD">
                  <FaUtensils className="me-1" /> {t('nav.apartadoD')}
                </Nav.Link>
              )}
            </Nav>
            <Nav>
              <NavDropdown title={<><FaLanguage className="me-1" /> {t('language')}</>} id="language-dropdown">
                <NavDropdown.Item onClick={() => changeLanguage('es')}>Español</NavDropdown.Item>
                <NavDropdown.Item onClick={() => changeLanguage('en')}>English</NavDropdown.Item>
              </NavDropdown>
              {!isLoggedIn ? (
                <NavDropdown title={<><FaSignInAlt className="me-1" /> {t('login.title')}</>} id="login-dropdown" align="end">
                  <Form className="px-4 py-3 form-login" onSubmit={handleLogin}>
                    {error && <Alert variant="outline-danger">{error}</Alert>}
                    <Form.Group controlId="formBasicUsername" className="mb-3">
                      <Form.Label>{t('login.username')}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t('login.enterUsername')}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword" className="mb-3">
                      <Form.Label>{t('login.password')}</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder={t('login.password')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Button type="submit" variant="outline-primary" className="w-100">
                      {t('login.submit')}
                    </Button>
                  </Form>
                </NavDropdown>
              ) : (
                
                <NavDropdown title={<><FaUser className="me-1" /> {user?.username}</>} id="user-dropdown" align="end">
               
                  <NavDropdown.Item onClick={handleLogout}>
                    <FaSignOutAlt className="me-1" /> 
                    {t('logout')}
                  </NavDropdown.Item>
                </NavDropdown>
              )}
              {isAdmin && (
                <Nav.Link as={Link} to="/admin">
                  <FaCog className="me-1" /> 
                </Nav.Link>
              )}

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="mt-4 cuerpo" >
        <Routes>
          
          <Route path="/" element={<ApartadoA />} />
          <Route path="/recipe/:id" element={<RecipeDetail5 />} />
          <Route 
            path="/recipe/new" 
            element={isLoggedIn ? <RecipeForm5  /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/recipe/edit/:id" 
            element={isLoggedIn ? <RecipeForm5  /> : <Navigate to="/" replace />} 
          />

          <Route 
            path="/apartadoB" 
            element={isAdmin ? <ApartadoB /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/admin" 
            element={isAdmin ? <ApartadoC /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/profile" 
            element={isLoggedIn ? <h1>{t('profile.title')}</h1> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/apartadoD" 
            element={isLoggedIn ? <RecipeSearch /> : <Navigate to="/" replace />} 
          />
          <Route path="*" element={<h1>{t('notFound')}</h1>} />
        </Routes>
      </Container>

     {/*  <footer className="bg-light text-center text-lg-start ">
        <div className="text-center p-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
          © {new Date().getFullYear()} {t('footer.copyright')}
        </div>
      </footer> */}
    </Router>
  );
};
export default App;
